import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import "./style.scss"
const SnowWrapper = styled.div`
position: relative;
width: 100%;
height: 100%;
overflow: hidden;
`
const SnowAnimator: FC<{ snowflakeCount?: number }> = ({
  snowflakeCount = 500,
}): ReactElement => {
  return (
    <SnowWrapper>
      {[...Array(snowflakeCount)].map((_, index) => {
        return <div className='snowflake' key={index} />
      })}
    </SnowWrapper>
  )
}
export default SnowAnimator
